import { useTheme } from '@emotion/react'

import {
  AllerganMonoLogo,
  AmbossMonoLogo,
  ChopraMonoLogo,
  RitualMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'

import { AllerganLogo, AmbossLogo, ChopraLogo, RitualLogo } from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `allergan`,
      logo: <AllerganMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <AllerganLogo />,
      logoName: `Allergan`,
    },
    {
      company: `amboss`,
      logo: <AmbossMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <AmbossLogo />,
      logoName: `Amboss`,
    },
    {
      company: `chopra`,
      logo: <ChopraMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <ChopraLogo />,
      logoName: `Chopra`,
    },
    {
      company: `ritual`,
      logo: <RitualMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <RitualLogo />,
      logoName: `Ritual`,
    },
  ]
}

export { testimonialData }
